import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../../store';
import { blobRequest, showVideoViewer, stopShowVideoViewer } from '../../store/videos/slices';
import ArrowLeft from '../ArrowLeft';
import ArrowRight from '../ArrowRight';
import CloseButtonImage from '../CloseButtonImage';
import Loading from '../Loading';
import { Container, Content, Video } from './styles'
import { IVideosState } from '../../store/videos/types';

interface Props {
    src: string;
}
const VideoViewer: React.FC<Props> = ({ src }) => {

    const blobVideo = useSelector((state: IApplicationState) => state.videos.blobs[src]);

    const videosState = useSelector(
        (state: IApplicationState) => state.videos
    ) as IVideosState

    const dispatch = useDispatch();

    const videoViewer = videosState.videosViewer

    useEffect(() => {
        if (!blobVideo) {
            dispatch(blobRequest({
                link: src
            }))
        }
    }, [blobVideo, dispatch, src])

    return <Container>
        <CloseButtonImage onClose={() => { dispatch(stopShowVideoViewer()) }} />
        <Content>
            <ArrowLeft onLeft={() => {
                if (videoViewer) {
                    dispatch(showVideoViewer({
                        ...videoViewer,
                        positionVideo: videoViewer.positionVideo > 0 ? videoViewer.positionVideo - 1 : videoViewer?.arrayVideo.length - 1
                    }))
                }
            }} />
            {blobVideo && blobVideo.isLoading && <Loading />}
            {blobVideo && blobVideo.blob && <Video loop muted autoPlay controls src={URL.createObjectURL(blobVideo.blob)} />}
            <ArrowRight onRight={() => {
                if (videoViewer) {
                    dispatch(showVideoViewer({
                        ...videoViewer,
                        positionVideo: videoViewer.positionVideo < (videoViewer.arrayVideo.length - 1) ? videoViewer.positionVideo + 1 : 0
                    }))
                }
            }} />
        </Content>
    </Container>
}

export default VideoViewer;